import type { Typographies } from "@superblocksteam/shared";

export const DEFAULT_SWITCH_WIDGET_LABEL_TEXT_STYLE_VARIANT: keyof Typographies =
  "inputLabel";
